import { render, staticRenderFns } from "./actionDropdown.vue?vue&type=template&id=54056ac8"
import script from "./actionDropdown.vue?vue&type=script&lang=js"
export * from "./actionDropdown.vue?vue&type=script&lang=js"
import style0 from "./actionDropdown.vue?vue&type=style&index=0&id=54056ac8&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports